const convertDateOverTime = (time) => {
    const intTime = time * 24 * 60 * 60
    const total_minutes = parseInt(Math.floor(intTime / 60));
    const total_hours = parseInt(Math.floor(total_minutes / 60));
    const days = parseInt(Math.floor(total_hours / 24)) !== 0 ? parseInt(Math.floor(total_hours / 24)) + 'd ' : '';

    const minutes = parseInt(total_minutes % 60) !== 0 ? parseInt(total_minutes % 60) + 'm ' : '';
    const hours = parseInt(total_hours % 24) !== 0 ? parseInt(total_hours % 24) + 'h ' : '';

    return days + hours + minutes;
}

export const convertDateOverTimeNew = (time) => {
    if(!!time){
        if(time < -1) {
            return null
        }else{
            if(time === 0) return '0d'
            const intTime = time * 24 * 60 * 60
            const total_minutes = intTime >= 0 ? Math.floor(intTime / 60) : Math.ceil(intTime / 60)
            const total_hours = (total_minutes >= 0 ? Math.floor(total_minutes / 60) : Math.ceil(total_minutes / 60))
            const total_days = total_minutes >= 0 ? Math.floor(total_hours / 24) : Math.ceil(total_hours / 24)
            const days = total_days !== 0 ? (total_days < 0 ? `(${total_days})` : total_days) + 'd' : ''
            const hours = parseInt(total_hours % 24) !== 0 ? (total_hours < 0 && !days ? `(${parseInt(total_hours % 24)})` : Math.abs(parseInt(total_hours % 24))) + 'h' : ''
        
            return days + hours
        }
    }
}

export const convertDateOverTimeProgress = (time) => {
    const total_minutes = Math.floor(time * 60);
    const days = Math.floor(total_minutes / (24 * 60));
    const hours = Math.floor((total_minutes % (24 * 60)) / 60);
    const minutes = total_minutes % 60;

    const dayString = days > 0 ? days + 'd ' : '0d ';
    const hourString = hours > 0 ? hours + 'h ' : '0h ';
    const minuteString = minutes > 0 ? minutes + 'm ' : '0m ';

    return dayString + hourString + minuteString;
}

export default convertDateOverTime